export default __webpack_public_path__ + "static/media/co.82bd7a3a.svg";